module.exports = __webpack_public_path__ + "img/zhibo-bg.5894aed0.png";